export default __webpack_public_path__ + "static/media/snx.72b3ffa2.svg";